// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"0f415465","712":"928fb468"}[chunkId] + ".chunk.js";
};